import { isArticleTileViewModel } from '@rocco/ui/tile-article/view-models/article';
import { isProfessionalTileViewModel } from '@rocco/ui/tile-professional/view-models/professional';
import { isProjectTileViewModel } from '@rocco/ui/tile-project/view-models/project';
import { isProductTileViewModel } from '@rocco/ui/tile-product/view-models/product';
import type { TileableModel } from '@rocco/ui/tile-shared/view-models/tile';
import type { PinItemType } from '../type';

/**
 * Which kind of pin a tile saves, and so which id the save is made from.
 *
 * Product must be checked before project: the duck-typed guards overlap.
 *
 * A project tile marked `isPhoto` is one photograph off the Spaces / Styles
 * wall rather than a project page, so it pins the picture. Saving it as a page
 * pin looks up the image's id among the pages, finds nothing, and writes no
 * pin — while the request still succeeds and the reader is told it saved.
 */
export const getPinType = (model: TileableModel): PinItemType => {
    if (isProfessionalTileViewModel(model)) {
        return 'ProfessionalPin';
    }

    if (isProductTileViewModel(model)) {
        return 'ProductPin';
    }

    if (isProjectTileViewModel(model)) {
        return model.isPhoto ? 'PhotoPin' : 'ProjectPin';
    }

    if (isArticleTileViewModel(model)) {
        return 'ArticlePin';
    }

    return 'ProductPin'; // default fallback
};
